import { render, staticRenderFns } from "./CatalogProductListContainer.vue?vue&type=template&id=d0dfec1a&"
import script from "./CatalogProductListContainer.vue?vue&type=script&lang=js&"
export * from "./CatalogProductListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports